import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PurchaseTable = ({ allPurchaseData, handledelete }) => {
  const { t } = useTranslation();

  return (
    <div className="dbMaintable respTable">
      <table>
        <thead>
          <tr>
            <th>{t("orderId")}</th>
            <th>{t("invoice_id")}</th>
            <th>{t("business_unit")}</th>
            <th>{t("dateOfGeneration")}</th>
            <th>{t("supplier_name")}</th>
            <th>{t("carbon_footprint")}</th>
            <th>{t("total_amount")}</th>
            <th>{t("order_status")}</th>
            <th>&nbsp;</th>
          </tr>
        </thead>

        <tbody>
          {allPurchaseData?.length !== 0 ? (
            allPurchaseData?.map((d, index) => (
              <tr key={index}>
                <td data-label="Order ID">
                  <Link to={`/purchaseorderdetail?id=${d?.id}`}>{d?.id}</Link>
                </td>
                <td data-label="Invoice ID">
                  <Link to="/">{d?.invoiceId}</Link>
                </td>
                <td data-label="Business Unit">
                  <Link to="/">{d?.businessUnitId}</Link>
                </td>
                <td data-label="Date of Generation">
                  <Link to="/">{d?.deliveryDateTime}</Link>
                </td>
                <td data-label="Supplier name">
                  <Link to="/">{d?.Supplier?.name}</Link>
                </td>
                <td data-label="Carbon footprint">
                  <Link to="/">{d?.filterCarbonFootPrint}</Link>
                </td>
                <td data-label="Total Amount">
                  <Link to="/">{d?.totalAmount}</Link>
                </td>
                <td data-label="Order Status">
                  <span className="dbu">{d?.orderStatus}</span>
                </td>
                <td data-label="Action">
                  {/* <button onClick={handleToggle} className="beye">
                            <i className="fa-light fa-eye"></i>
                            <i className="fa-light fa-eye-slash"></i>
                          </button> */}
                  &nbsp;&nbsp;
                  <Link to={`/purchaseorderdetail?id=${d?.id}`}>
                    <i className="fa-light fa-pen"></i>
                  </Link>
                  &nbsp;&nbsp;
                  <i
                    className="fa-regular fa-trash"
                    style={{ cursor: "pointer" }}
                    onClick={() => handledelete(d?.id)}
                  ></i>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={8}>No Data Available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PurchaseTable;
